/**
 * 矢印アニメーションの「帰り」を有効化する
 *
 * @description Figma（406:2420）の矢印はホバーを外したときも来た道を戻らず、
 *              そのまま右へ抜けきってから左から入り直す。
 *              行きと帰りで経路が違うのでCSSはkeyframesを2本持っているが、
 *              帰りぶんは「非ホバー状態」に当たるためページ読み込み直後にも再生されてしまう。
 *              そこで行きのアニメーションが一度でも走ったボタンにだけ .is-armed を付けて、
 *              実際にホバーを外したとき以降だけ帰りが再生されるようにする。
 *              対象は .Btn のリンクと、WORKS・VOICEの送りボタン、フォームの確認・送信・サンクスのボタン（同じkeyframesを共用）。
 */

/** 矢印の動きを持つボタンのセレクタ */
const ARROW_BTN_SELECTOR = ".Btn a, .voice__arrow, .works__arrow, .Form__btn--next, .Form__btn--submit, .Form__btn--thanks"

/**
 * ボタン1つに帰りのアニメーションを仕込む
 * @param {HTMLElement} btn - .Btn 内のリンク要素、または .voice__arrow / .works__arrow / .Form__btn--next / .Form__btn--submit / .Form__btn--thanks
 * @returns {void}
 * @description animationstartは矢印（.Arrow__inner / .voice__arrowInner / .works__arrowInner / .Icon__inner）から伝播してくる。
 *              ホバーでもキーボードフォーカスでも行きが走るので、どちらでも有効化される。
 * @example
 * arm(document.querySelector(".Btn a"))
 */
const arm = (btn: HTMLElement): void => {
  btn.addEventListener(
    "animationstart",
    () => {
      btn.classList.add("is-armed")
    },
    { once: true },
  )
}

document.querySelectorAll<HTMLElement>(ARROW_BTN_SELECTOR).forEach(arm)
